
























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import Link from '@/components/Link'

@Component
class SectionList extends mixins(SectionCore) {
  @Prop() readonly list: ReadonlyArray<any> = []
  @Prop() readonly coverEagle: boolean = false
  @Prop() readonly typeLink: string = ''
}

export default defineComponent({
  name: 'SectionPopularRelink',
  components: {
    SectionBasic,
    Link,
  },
  props: SectionList.options.props,
})
